import { Box, Typography } from "@husqvarna/ui-core";
import { FormattedMessage } from "react-intl";
import { Product } from "../../../../../models/Product";
import { UnitSystem, CuttingQuality } from "../../../../../models/Enums";
import { getTotalAreaForUnitSystem } from "../../../../../../shared/utils";
import ColorTile from "../../../../../../shared/components/ColorTile/ColorTile";
import { getColorClassForColor, getColorAlt } from "../../../../../../shared/constants/proposalProductColors";

export type MowerFeaturesProps = {
  selectedProduct?: Product;
  quantity: number;
  unitSystem: UnitSystem
  colorHex?: string;
} 

const MowerFeatures = ({
  selectedProduct,
  quantity,
  unitSystem,
  colorHex
} : MowerFeaturesProps) => {
  
  const colorClass = colorHex ? getColorClassForColor(colorHex) : undefined;
  
  return (
  <Box
    justifyContent="space-between"
    flexDirection="column"
  >
    <Box>
      <Typography variant="Subtitle2" tag="h2" text={selectedProduct?.name}>
        <Box component="span">{selectedProduct?.name}</Box>
        {colorClass && (
          <ColorTile color={colorClass} size="medium" />
        )}
      </Typography>
    </Box>
    <Box alignItems="center" gap={1}>
      <Typography variant="Microcopy" tag="h5" color="Grey500">
        <FormattedMessage
          id="projects.equipment.MaxRegularCapacity"
          defaultMessage="Maximum capacity:"
        />
      </Typography>
      <Typography variant="Microcopy" color="Grey500">
        {selectedProduct && (
          getTotalAreaForUnitSystem(((selectedProduct.maxAreaSizes[CuttingQuality.Regular] || 0) * quantity), unitSystem)
        )}
      </Typography>
    </Box>
    <Box alignItems="center" gap={1}>
      <Typography variant="Microcopy" tag="h5" color="Grey500">
        <FormattedMessage
          id="general.slope.maximumSlope"
          defaultMessage="Maximum slope:"
        />
      </Typography>
      <Typography variant="Microcopy" color="Grey500">
        {selectedProduct && (
          <FormattedMessage
            id="general.slope.maximumSlopeValue"
            defaultMessage="{slope}%"
            values={{
              slope: selectedProduct.maxSlope
            }}
          />)
        }
      </Typography>
    </Box>
  </Box>
)};

export default MowerFeatures;
